import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/credits/credits-icon@3x.png';
const _withScopeId = n => (_pushScopeId("data-v-ece58a2a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "palcode-popup rwd-popup"
};
const _hoisted_2 = {
  key: 0,
  class: "popup-main"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ico-close-o"
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  class: "popup-img"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popup-title"
}, "推荐好友", -1));
const _hoisted_7 = {
  class: "popup-body"
};
const _hoisted_8 = {
  class: "palcode-tab-text"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_10 = {
  class: "palcode-tab-text"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_12 = {
  key: 1,
  class: "palcode-content"
};
const _hoisted_13 = {
  class: "border"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "palcode-content-header"
}, "复制以下推荐码给被推荐人", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "label"
}, "我的推荐码", -1));
const _hoisted_17 = {
  class: "text text-brand-red"
};
const _hoisted_18 = {
  key: 2,
  class: "palcode-content"
};
const _hoisted_19 = {
  class: "border"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "palcode-content-header"
}, "输入好友的推荐码，提交即可完成推荐", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "label"
}, "我的推荐码", -1));
const _hoisted_23 = {
  class: "palcode-content-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  const _component_ClipboardBtn = _resolveComponent("ClipboardBtn");
  const _component_van_field = _resolveComponent("van-field");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "popup-overlay pointer",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.close && $setup.close(...args))
  }), $setup.state.isGetData ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
    class: "popup-close",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.close && $setup.close(...args))
  }, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_image, {
    class: "w-100",
    fit: "contain",
    position: "center",
    src: require('@/assets/images/palcode/palcode-popup-img@3x.png')
  }, null, 8, ["src"])]), _hoisted_6, _createElementVNode("div", _hoisted_7, [!$setup.myPlacode.isGetRecommendedBonus ? (_openBlock(), _createBlock(_component_van_row, {
    key: 0,
    wrap: false,
    class: "palcode-tab-group",
    justify: "space-between"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_col, {
      class: ""
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: _normalizeClass(["palcode-tab-item", {
          '--active': $setup.state.tabValue === 1
        }])
      }, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("span", null, _toDisplayString(_ctx.$filters.priceFormatInt(+$setup.palcodeBonus.beRecommender)) + "福米", 1)]), _createVNode(_component_van_button, {
        round: "",
        class: _normalizeClass(["btn-brand", $setup.state.tabValue === 1 ? 'btn-brand-red' : 'btn-default']),
        onClick: _cache[2] || (_cache[2] = $event => $setup.state.tabValue = 1)
      }, {
        default: _withCtx(() => [_createTextVNode("我是推荐人 ")]),
        _: 1
      }, 8, ["class"])], 2)]),
      _: 1
    }), _createVNode(_component_van_col, {
      class: ""
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: _normalizeClass(["palcode-tab-item", {
          '--active': $setup.state.tabValue === 2
        }])
      }, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", null, _toDisplayString(_ctx.$filters.priceFormatInt(+$setup.palcodeBonus.recommendedBy)) + "福米", 1)]), _createVNode(_component_van_button, {
        round: "",
        class: _normalizeClass(["btn-brand", $setup.state.tabValue === 2 ? 'btn-brand-red' : 'btn-default']),
        onClick: _cache[3] || (_cache[3] = $event => $setup.state.tabValue = 2)
      }, {
        default: _withCtx(() => [_createTextVNode("我是被推荐人 ")]),
        _: 1
      }, 8, ["class"])], 2)]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), $setup.state.tabValue === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _hoisted_15, _createVNode(_component_van_row, {
    wrap: false,
    align: "center",
    class: "palcode-content-body"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_col, {
      class: "col-auto"
    }, {
      default: _withCtx(() => [_hoisted_16]),
      _: 1
    }), _createVNode(_component_van_col, {
      class: "col-fill palcode-value --readonly"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_17, _toDisplayString($setup.myPlacode.value), 1)]),
      _: 1
    }), _createVNode(_component_van_col, {
      class: "col-auto"
    }, {
      default: _withCtx(() => [_createVNode(_component_ClipboardBtn, {
        size: "small",
        round: "",
        class: "btn-brand btn-brand-blue",
        value: $setup.myPlacode.value
      }, null, 8, ["value"])]),
      _: 1
    })]),
    _: 1
  })])])) : _createCommentVNode("", true), $setup.state.tabValue === 2 && !$setup.myPlacode.isGetRecommendedBonus ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _hoisted_21, _createVNode(_component_van_row, {
    wrap: false,
    align: "center",
    class: "palcode-content-body"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_col, {
      class: "col-auto"
    }, {
      default: _withCtx(() => [_hoisted_22]),
      _: 1
    }), _createVNode(_component_van_col, {
      class: "col-fill palcode-value --input"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: $setup.state.palcodeValue,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.state.palcodeValue = $event),
        placeholder: "请输入好友推荐码"
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_23, [_createVNode(_component_van_button, {
    round: "",
    block: "",
    class: "btn-brand btn-brand-red",
    onClick: $setup.applyPalcode
  }, {
    default: _withCtx(() => [_createTextVNode("提交")]),
    _: 1
  }, 8, ["onClick"])])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]);
}